(function($) {

    if( $('.homepage-slider').length ) {
        var $status = $('.slide-count');
        var $slickElement = $('.homepage-hero .homepage-slider');

        // $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //     var i = (currentSlide ? currentSlide : 0) + 1;
        //     $status.html(i + '<span>/</span>' + slick.slideCount);
        // });

        $(".homepage-slider").slick({
            arrows: false,
            dots: false,
            autoplay: true,
            autoplaySpeed: 4000,
            fade: true,
            rows: 0,
            infinite: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        fade: false,
                        autoplay: true,
                        autoplaySpeed: 4000,
                        centerMode: false,
                        slidesToShow: 1,
                        infinite: true,
                    }
                }
            ]
        });

        $('.homepage-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            var slides = $('.homepage-slider').slick("getSlick").$slides;
            var bg = slides.eq( nextSlide ).data("bg");
            $('body .navigation').attr('data-color', bg);
        });

        var spacing = function(){
            if(window.innerWidth > 992){
                $('.homepage-slider .slide').each(function(){
                    let h1Height = $(this).find('h1').height();
                    let pHeight = $(this).find('p').height();
        
                    var svgHeight = $(this).find("svg.slider-text text")[0].getBBox().height;
    
                    if ( $(this).find("svg.slider-text text").children().length > 0 ) {
                        var reduceHeight = $(this).find("svg.slider-text text tspan")[0].getBBox().height / 2;
                        svgHeight = svgHeight - reduceHeight;
                        pHeight = pHeight + svgHeight/2 + 40;
                    }
        
                    let totaH1lHeight = h1Height + svgHeight/2;
                    let cssh1Height = "calc(50% - " + totaH1lHeight + "px)";
        
                    let cssPHeight = "calc(50% + " + pHeight + "px)";
        
                    $(this).find('h1').css("top", cssh1Height);
                    $(this).find('p').css("top", cssPHeight);
                });
            }
        }
        spacing();
        $(window).on('resize', function(){
            spacing();
        });
    }
})( jQuery );